var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-treeview',{attrs:{"dense":"","hoverable":"","items":_vm.routeTrack},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
return [(item.warning)?_c('span',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(item.name)+" ")]):_c('span',[_vm._v(" "+_vm._s(item.name)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }